module.exports = {
      id: "instagram-square-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-b35941cc40d7fc0f39708cadaf87d26a.svg#instagram-square",
      toString: function () {
        return this.url;
      }
    }